export default __webpack_public_path__ + "static/media/621.7c112b11.jpg";